import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  Select,
  ListItemText,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button';
// import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import * as api from '../../../services/api/admin';
import * as authApi from '../../../services/api/auth';

function ProfileInsertModal(props) {
  const {
    provider,
    open,
    onClose,
    openInsertModal,
    setOpenInsertModal,
    availableSections,
    availableCategories,
    availableCategoriesForCredentialsResearch,
    refresh,
    classes: { modal, modalContent, selectInput, input, helperText },
  } = props;

  const [content, setContent] = useState('');
  const [linkTo, setLinkTo] = useState('');
  const [description, setDescription] = useState('');
  const [newSection, setNewSection] = useState(openInsertModal.section);
  const [newCategory, setNewCategory] = useState('');
  const [currentUser, setCurrentUser] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setNewSection(openInsertModal.section);
      const resultingUser = await authApi.fetchCurrentUser();
      setCurrentUser(resultingUser);
    })();
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (open) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [open]);

  const createProfileContent = async item => {
    setLoading(true);
    const contentDetails = {
      ...item,
      providerId: provider.id,
      updatedLastBy: currentUser.id,
    };
    await api.createProfileContent(contentDetails);
    if (provider.id) {
      await api.fetchContentsByProviderId(provider.id);
    }

    onClose();
    setContent('');
    setLinkTo('');
    setDescription('');
    setNewCategory('');
    setLoading(false);
  };

  const resetForm = () => {
    setContent('');
    setLinkTo('');
    setDescription('');
    setNewCategory('');
  };

  const dynamicHelperText = (category) => {
    let msg = "";
    if (category === "link") {
      msg = "URL goes here. Make sure to enter the website link! (Ex: https://qwell.com)";
    } else if (category === "image") {
      msg = "URL goes here. Make sure to enter the image url.";
    } else if (category === "video") {
      msg = "URL goes here. Make sure you are getting the embedded link! They are often under *share*... https://www.youtube.com/embed/DwjMCtjxtTg";
    }

    return msg;
  };

  const normalizeUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
  };

  const handleLink = (event) => {
    let value = event.target.value;
    if (newCategory == 'link') {
      const normalizeUrl = (value);
      setLinkTo(normalizeUrl);
    } else {
      setLinkTo(value);
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        onClose();
        resetForm();
      }}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} className="headingSize">
            <h2>Insert New Content</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton
              aria-label="Close"
              onClick={() => {
                onClose();
                resetForm();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: modalContent }}>
        <FormHelperText className={helperText}>Section</FormHelperText>

        <Select
          fullWidth
          variant="outlined"
          label="Section"
          name="newSection"
          value={openInsertModal.section}
          className={selectInput}
          onChange={event => {
            setOpenInsertModal({ section: event.target.value, bool: true });
          }}
        >
          {availableSections.map(section => (
            <MenuItem key={`menu-${section}`} value={section}>
              <ListItemText primary={section} />
            </MenuItem>
          ))}
        </Select>
        <FormHelperText className={helperText}>
          Category of source
        </FormHelperText>
        <Select
          fullWidth
          variant="outlined"
          label="Category"
          name="newCategory"
          className={selectInput}
          value={newCategory}
          onChange={event => {
            setNewCategory(event.target.value);
          }}
        >
          {
            openInsertModal.section === 'credentials-research' ? (
              availableCategoriesForCredentialsResearch.map(category => (
                <MenuItem key={`menu-${category}`} value={category}>
                  <ListItemText primary={category} />
                </MenuItem>
              ))
            ) : (
              availableCategories.map(category => (
                <MenuItem key={`menu-${category}`} value={category}>
                  <ListItemText primary={category} />
                </MenuItem>
              ))
            )
          }
        </Select>

        {newCategory !== 'text' && (
          <TextField
            variant="outlined"
            fullWidth
            name="linkTo"
            value={linkTo}
            className={input}
            onChange={handleLink}
            multiline
            rows="1"
            helperText={dynamicHelperText(newCategory) || "URL goes here. Make sure you are getting the embedded link! They are often under *share*... https://www.youtube.com/embed/DwjMCtjxtTg"}

          />
        )}
        {newCategory === 'text' && (
          <TextField
            whitespace="pre-wrap"
            variant="outlined"
            fullWidth
            name="content"
            value={content}
            className={input}
            onChange={event => {
              setContent(event.target.value);
            }}
            multiline
            InputProps={{ whiteSpace: 'pre-line' }}
            rows="4"
            helperText="If you selected the text option, insert text here"
          />
        )}
        {/* <TextField
          variant="outlined"
          fullWidth
          name="description"
          value={description}
          className={input}
          onChange={event => {
            setDescription(event.target.value);
          }}
          multiline
          rows="1"
          helperText="What is this about? Write a short description"
        /> */}
        <Button
          onClickSuccessSnackbar="Content was sucessfully submitted."
          onClickFailSnackbar="Content could not be submitted"
          color="primary"
          variant="contained"
          onClick={() =>
            createProfileContent({
              section: openInsertModal.section,
              category: newCategory,
              content,
              linkTo: normalizeUrl(linkTo),
              description,
            })
          }
          className="editSubmitBtn"
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </Button>
      </DialogContent>
    </Dialog>
  );
}

const styles = () => ({
  modal: {
    maxWidth: '1000px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  selectInput: {
    margin: '0.5em',
  },
  input: {
    margin: '0.2em',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },

});

export default withStyles(styles)(ProfileInsertModal);
